/* tslint:disable:directive-selector */

import {
  Directive, HostListener, ComponentRef, ViewContainerRef, ComponentFactoryResolver, OnInit, ElementRef, DoCheck, HostBinding
} from '@angular/core';
import { PasswordStrengthComponent } from './password.strength.component';
import { PasswordStrengthService } from '../../services/form.validations/password.strength.service';

@Directive({
  selector: '[passwordStrength]',
})
export class PasswordStrengthDirective implements OnInit, DoCheck {

  private passwordStrengthComponent: ComponentRef<PasswordStrengthComponent>;
  private visible: boolean;

  @HostBinding('style.position')
  postion = 'static';

  constructor(private viewContainerRef: ViewContainerRef, private el: ElementRef,
    private resolver: ComponentFactoryResolver, private passwordService: PasswordStrengthService) {
  }

  ngOnInit() {
    this.visible = false;
  }

  ngDoCheck() {
    if (!this.el.nativeElement.value) {
      this.hide();
    }
  }

  @HostListener('keyup', ['$event'])
  @HostListener('change', ['$event'])
  onChange(e: any): void {
    const value = e.target.value;
    if (value.length === 0) {
      this.hide();
    } else {
      this.show();
      let pass = this.passwordService.getStrength(value);
      this.passwordStrengthComponent.instance.width = pass.score + '%';
      this.passwordStrengthComponent.instance.color = pass.color;
    }
  }

  show(): void {
    if (this.visible) {
      return;
    }

    this.visible = true;
    const factory = this.resolver.resolveComponentFactory(PasswordStrengthComponent);
    if (!this.visible) {
      return;
    }
    this.passwordStrengthComponent = this.viewContainerRef.createComponent(factory);
  }

  hide(): void {
    if (!this.visible) {
      return;
    }

    this.visible = false;
    if (this.passwordStrengthComponent) {
      this.passwordStrengthComponent.destroy();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/components/password.strength/password.strength.directive.ts